export default {
  primary: '#4CAF50',
  secondary: '#2E7D32',
  accent: '#FF9800',
  error: '#f44336',
  warning: '#FDD835',
  info: '#2196f3',
  success: '#4caf50'
}



// WEBPACK FOOTER //
// ./src/theme.js